import { NavigateMode } from 'common/reducers/appConfig';
import NavigateModeEvent from 'common/utils/NavigateModeEvent';
import { useCallback, useEffect, useMemo, useState } from 'react';

const useHoverable = (focusedState: boolean) => {
  const [navigateMode, setNavigateMode] = useState<NavigateMode>('DIRECTIONAL');
  useEffect(() => {
    const handleChange = (mode: NavigateMode) => {
      setNavigateMode(mode);
    };
    NavigateModeEvent.on(handleChange);
    return () => {
      NavigateModeEvent.off(handleChange);
    };
  }, []);

  const [hovered, setHovered] = useState(false);

  const onMouseEnter = useCallback(() => {
    setHovered(true);
  }, []);

  const onMouseLeave = useCallback(() => {
    setHovered(false);
  }, []);

  useEffect(() => {
    navigateMode === 'DIRECTIONAL' && setHovered(false);
  }, [navigateMode]);

  const active = useMemo(() => {
    return { DIRECTIONAL: focusedState, POINTER: hovered }[navigateMode];
  }, [focusedState, hovered, navigateMode]);

  return { active, onMouseEnter, onMouseLeave };
};

export default useHoverable;
